import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { SHAPES } from '../const.mjs';
var Polygon = /*#__PURE__*/function () {
  function Polygon() {
    _classCallCheck(this, Polygon);
    for (var _len = arguments.length, points = new Array(_len), _key = 0; _key < _len; _key++) {
      points[_key] = arguments[_key];
    }
    var flat = Array.isArray(points[0]) ? points[0] : points;
    if (typeof flat[0] !== "number") {
      var p = [];
      for (var i = 0, il = flat.length; i < il; i++) {
        p.push(flat[i].x, flat[i].y);
      }
      flat = p;
    }
    this.points = flat;
    this.type = SHAPES.POLY;
    this.closeStroke = true;
  }
  _createClass(Polygon, [{
    key: "clone",
    value: function clone() {
      var points = this.points.slice();
      var polygon = new Polygon(points);
      polygon.closeStroke = this.closeStroke;
      return polygon;
    }
  }, {
    key: "contains",
    value: function contains(x, y) {
      var inside = false;
      var length = this.points.length / 2;
      for (var i = 0, j = length - 1; i < length; j = i++) {
        var xi = this.points[i * 2];
        var yi = this.points[i * 2 + 1];
        var xj = this.points[j * 2];
        var yj = this.points[j * 2 + 1];
        var intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
        if (intersect) {
          inside = !inside;
        }
      }
      return inside;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "[@pixi/math:PolygoncloseStroke=".concat(this.closeStroke, "points=").concat(this.points.reduce(function (pointsDesc, currentPoint) {
        return "".concat(pointsDesc, ", ").concat(currentPoint);
      }, ""), "]");
    }
  }]);
  return Polygon;
}();
export { Polygon };